var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents_wrapper"},[_c('ClientScoreBox',{attrs:{"client":_vm.client}}),_c('div',{staticClass:"contents"},[_c('p',{staticClass:"large_white_label"},[_vm._v("クライアントマイページ")]),_c('ClientButtonBlock')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }